import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectQuotView } from '../../Selectors/Master/ItemSelectors';
import { fetchQuotViewlist } from '../../../Store/PHPSlice/Sale/Quotation';

import { Grid, Paper } from '@mui/material';

const RateAnalysis = () => {
    const [formData, setFormData] = useState({
        quotNo: '',
        itemNm: '',
        firmNm: '',
        priceNm: '',
        partyNm: '',
        schlNm: '',
        jobrate: '',
        outSrc: '',
        extra: '',
        mcloth: '',
        mrate: '',
        mpanna: '',
        m1cloth: '',
        m1rate: '',
        m1panna: '',
        m2cloth: '',
        m2rate: '',
        m2panna: '',
        m3cloth: '',
        m3rate: '',
        m3panna: '',
        qty: [],
        mainMtr: [],
        m1Mtr: [],
        m2Mtr: [],
        m3Mtr: [],
        loss: "",
        profit: ''
    });
    const { Id } = useParams();
    const dispatch = useDispatch();
    const viewlist = useSelector(selectQuotView);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed
    useEffect(() => {
        dispatch(fetchQuotViewlist(Id))
    }, [Id, dispatch]);
    console.log(viewlist)
    useEffect(() => {
        if (viewlist.data && viewlist.data.length > 0) {
            const item = viewlist.data[0];
            setFormData(prev => ({
                ...prev,
                quotNo: item.quotNo || '',
                itemNm: item.itemNm || '',
                firmNm: item.firmNm || '',
                priceNm: item.grpNm || '',
                partyNm: item.partyNm || '',
                schlNm: item.schoolNm || '',
                jobrate: item.jobrate || '',
                outSrc: item.outSrc || '',
                extra: item.extra || '',
                mcloth: item.clothNm || '',
                mrate: item.rate || '',
                mpanna: item.panna || '',
                m1cloth: item.m1cloth || '',
                m1rate: item.m1rate || '',
                m1panna: item.m1panna || '',
                m2cloth: item.m2cloth || '',
                m2rate: item.m2rate || '',
                m2panna: item.m2panna || '',
                m3cloth: item.m3cloth || '',
                m3rate: item.m3rate || '',
                m3panna: item.m3panna || '',
                loss: item.loss || '',
                profit: item.profit || ''
            }));
        }
    }, [viewlist]);
    const handleQtyChange = (index, value) => {
        setFormData(prevFormData => {
            const newQty = [...prevFormData.qty];
            newQty[index] = value;
            return { ...prevFormData, qty: newQty };
        });
    };


    const tableContainerStyle = {
        // marginLeft: isDesktop ? '5%' : '0%',
        // width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };
    var itemData = viewlist.avgs.length > 0 ? {
        size: viewlist.avgs.map(val => val.size),
        mavg: viewlist.avgs.map(val => parseFloat(val.mavg)),
        m1avg: viewlist.avgs.map(val => parseFloat(val.m1avg)),
        m2avg: viewlist.avgs.map(val => parseFloat(val.m2avg)),
        m3avg: viewlist.avgs.map(val => parseFloat(val.m3avg)),
        rate: viewlist.avgs.map(val => parseFloat(val.rate)),
        mrp: viewlist.avgs.map(val => parseFloat(val.mrp))
    } : [];




    const renderTableRow = (size, index) => {
        const newAvgM = itemData.mavg[index];
        const newAvgM1 = itemData.m1avg[index];
        const newAvgM2 = itemData.m2avg[index];
        const newAvgM3 = itemData.m3avg[index];

        var outSrc = parseFloat(formData.outSrc);

        var mCal = parseFloat(formData.mrate) * parseFloat(outSrc) / 100 + parseFloat(formData.mrate);
        var m1Cal = parseFloat(formData.m1rate) * parseFloat(outSrc) / 100 + parseFloat(formData.m1rate);
        var m2Cal = parseFloat(formData.m2rate) * parseFloat(outSrc) / 100 + parseFloat(formData.m2rate);
        var m3Cal = parseFloat(formData.m3rate) * parseFloat(outSrc) / 100 + parseFloat(formData.m3rate);

        if (formData.qty[index]) {



            var calavgM = parseFloat(newAvgM) * parseFloat(formData.qty[index]);
            var calavgM1 = parseFloat(newAvgM1) * parseFloat(formData.qty[index]);
            var calavgM2 = parseFloat(newAvgM2) * parseFloat(formData.qty[index]);
            var calavgM3 = parseFloat(newAvgM3) * parseFloat(formData.qty[index]);

            var maincolth = calavgM * mCal;
            var m1cloth = calavgM1 * m1Cal;
            var m2cloth = calavgM2 * m2Cal;
            var m3cloth = calavgM3 * m3Cal;

            var clothrate = maincolth + m1cloth + m2cloth + m3cloth;

            var jobrate = viewlist.data.length > 0 ? viewlist.data.map(val => parseFloat(val.jobrate)) : 0;
            var calJob = parseFloat(jobrate) + clothrate;
        } else {
            calavgM = parseFloat(newAvgM) * mCal;
            calavgM1 = parseFloat(newAvgM1) * m1Cal;
            calavgM2 = parseFloat(newAvgM2) * m2Cal;
            calavgM3 = parseFloat(newAvgM3) * m3Cal;

            const jobrate2 = viewlist.data.length > 0 ? viewlist.data.map(val => parseFloat(val.jobrate)) : 0;
            clothrate = calavgM + calavgM1 + calavgM2 + calavgM3;
            calJob = parseFloat(jobrate2) + clothrate;
        }

        var calLoss = (calJob) * parseFloat(formData.loss) / 100;
        var valueLoss = Math.round(calJob + calLoss);

        var extra = viewlist.data.length > 0 ? viewlist.data.map(val => parseFloat(val.extra)) : 0;

        var calextra = Math.round(parseFloat(extra) + valueLoss);

        var calprofit = calextra * parseFloat(formData.profit) / 100;
        var profit = Math.round(calextra + calprofit);

        var crate = itemData.rate[index];

        return (
            <TableRow key={index}>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>{size}</TableCell>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>
                    <input
                        type="text"
                        value={formData.qty[index] || ''}
                        onChange={(e) => handleQtyChange(index, e.target.value)}
                        style={{ width: '40px', padding: '1px' }}
                    />
                </TableCell>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>{newAvgM}</TableCell>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>{formData.mrate}</TableCell>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>
                    <input
                        type="text"
                        value={ Math.round(calavgM)}
                        style={{ width: '40px', padding: '1px' }}
                    />
                </TableCell>
                {formData.m1cloth !== '0' &&
                    <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>{newAvgM1}</TableCell>}
                {formData.m1cloth !== '0' && <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>{formData.m1rate}</TableCell>}
                {formData.m1cloth !== '0' && <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>
                    <input
                        type="text"
                        value={ Math.round(calavgM1)}
                        style={{ width: '40px', padding: '1px' }}
                    />
                </TableCell>}
                {formData.m2cloth !== '0' &&
                    <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>{newAvgM2}</TableCell>}
                {formData.m2cloth !== '0' && <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>{formData.m2rate}</TableCell>}
                {formData.m2cloth !== '0' && <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>
                    <input
                        type="text"
                        value={ Math.round(calavgM2)}
                        style={{ width: '40px', padding: '1px' }}
                    /></TableCell>}
                {formData.m3cloth !== '0' &&
                    <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>{newAvgM3}</TableCell>}
                {formData.m3cloth !== '0' && <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>{formData.m3rate}</TableCell>}
                {formData.m3cloth !== '0' && <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>
                    <input
                        type="text"
                        value={ Math.round(calavgM3)}
                        style={{ width: '40px', padding: '1px' }}
                    />
                </TableCell>}
                <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>
                    <input
                        type="text"
                        value={Math.round(clothrate)}
                        style={{ width: '50px', padding: '1px' }}
                    />

                </TableCell>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>
                    <input
                        type="text"
                        value={Math.round(calJob)}
                        style={{ width: '50px', padding: '1px' }}
                    />

                </TableCell>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>{Math.round(valueLoss)}</TableCell>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>{Math.round(calextra)}</TableCell>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>{Math.round(profit)}</TableCell>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }}>{crate}</TableCell>
            </TableRow>
        );
    };


    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '1vh', margin: '0' }}>
                    <div style={{ margin: '1%', width: '100%' }} ref={componentRef}>

                        <h3 className='centered-heading'>Rate Analysis</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>

                            <tbody>
                                <tr>
                                    <td style={{ width: '200px' }}>Quot No.</td>

                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='light-color'>{formData.quotNo}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Job Rate</td>

                                    <td style={{ padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.jobrate}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: '200px' }}>Item Name</td>

                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='light-color'>{formData.itemNm}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Extra</td>

                                    <td style={{ width: '30vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.extra}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Firm Name</td>

                                    <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formData.firmNm}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Out Source <br /><span style={{ color: 'red', fontSize: '12px' }}>(Main + Matching)</span></td>

                                    <td style={{ width: '30vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.outSrc}</td>
                                </tr>

                                <tr>
                                    {formData.priceNm !== "" &&
                                        <>
                                            <td style={{ width: '200px' }}>Price List</td>

                                            <td style={{ width: '25vw', padding: ' 0 1.5%' }}>{formData.priceNm}</td>
                                        </>
                                    }
                                    {formData.m1cloth !== '0' && (
                                        <>
                                            <td style={{ width: '200px', paddingLeft: '2%' }}>Matching Cloth-1</td>

                                            <td style={{ padding: '0.2% 1.5%' }} className='light-color'>{formData.m1cloth} <b>Panna: {formData.m1panna}</b> <b className='red-color'> Rate: {formData.m1rate}</b></td>
                                        </>
                                    )}
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Main Cloth</td>

                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.mcloth} <b>Panna:{formData.mpanna}</b> <b className='red-color'>Rate:{formData.mrate}</b></td>
                                    {formData.m2cloth !== '0' && (
                                        <>
                                            <td style={{ width: '200px', paddingLeft: '2%' }}>Matching Cloth-2</td>

                                            <td style={{ padding: '0.2% 1.5%' }} className='light-color'>{formData.m2cloth} <b>Panna: {formData.m2panna}</b> <b className='red-color'> Rate: {formData.m2rate}</b></td>
                                        </>
                                    )}
                                </tr>
                                <tr>
                                    <td style={{ width: '200px' }}>Party</td>

                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='dark-color'>{formData.partyNm}</td>
                                    {formData.m3cloth !== '0' && (
                                        <>
                                            <td style={{ width: '200px', paddingLeft: '2%' }}>Matching Cloth-3</td>

                                            <td style={{ padding: '0.2% 1.5%' }} className='light-color'>{formData.m3cloth} <b>Panna: {formData.m3panna}</b> <b className='red-color'> Rate: {formData.m3rate}</b></td>
                                        </>
                                    )}
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>School</td>

                                    <td style={{ width: '25vw', padding: '  0.2% 1.5%' }} className='dark-color'>{formData.schlNm}</td>

                                </tr>
                                <tr>
                                    <td style={{ width: '200px' }}>Profit</td>

                                    <td style={{ width: '25vw', padding: '  0.2% 1.5%' }} className='dark-color'>{formData.profit}</td>
                                    <td style={{ width: '200px' }}>Loss</td>

                                    <td style={{ width: '25vw', padding: '  0.2% 1.5%' }} className='dark-color'>{formData.loss}</td>

                                </tr>

                            </tbody>

                        </table>


                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                                <TableHead>
                                    <TableRow className='tbl-row'>
                                        <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Size</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Qty</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Avg. Mtr</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Main Avg. Rate</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Main Mtr</TableCell>
                                        {formData.m1cloth !== '0' &&
                                            <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>M1 Avg. Mtr</TableCell>}
                                        {formData.m1cloth !== '0' &&
                                            <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>M1 Avg. Rate</TableCell>}
                                        {formData.m1cloth !== '0' &&
                                            <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>M1 Mtr</TableCell>}
                                        {formData.m2cloth !== '0' &&
                                            <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>M2 Avg. Mtr</TableCell>}
                                        {formData.m2cloth !== '0' &&
                                            <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>M2 Avg.Rate</TableCell>}
                                        {formData.m2cloth !== '0' &&
                                            <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>M2 Mtr</TableCell>}
                                        {formData.m3cloth !== '0' &&
                                            <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>M3 Avg. Mtr</TableCell>}
                                        {formData.m3cloth !== '0' &&
                                            <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>M3 Avg.Rate</TableCell>}
                                        {formData.m3cloth !== '0' &&
                                            <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>M3 Mtr</TableCell>}
                                        <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Cloth Total</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Job Total</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Value Loss {`${formData.loss}%`}</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Extra</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Profit / Final Rate {`${formData.profit}%`}</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Change Rate</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {itemData.size ? itemData.size.map((item, index) => renderTableRow(item, index)) : ''}
                                </TableBody>
                            </Table>
                        </TableContainer>

                    </div>
                    <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <Button variant="contained" color="primary">Confirm</Button>
                    </div>
                </Paper>
            </Grid>
        </>
    );
};

export default RateAnalysis;
